import React from 'react'

import LogoProyecto from './../../UI/Logos/logo-proyecto.svg'

interface Props{
    isLoading: boolean
    isWelcome: boolean
    handleHideWelcome: any
}

interface State{}

class WelcomeScreen extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(){
        return(
            <div className={this.props.isLoading || this.props.isWelcome ? "welcome-container fade-out":"welcome-container fade-in"}>
                <div className='logo-proyecto-container'>
                    <img src={LogoProyecto}/>
                </div>
                <div className='text-container'>
                    <div className='legal-text'>
                        Las imágenes publicadas, planos, renders y demás piezas publicitarias son representaciones digitales del diseño y junto con el apartamento modelo exhibido en la sala de ventas, 
                        pueden variar en su percepción y construcción final y están sujetos a modificación y cambios sin previo aviso o consulta, por lo tanto, no constituyen oferta por parte del promotor y/o constructor. 
                        Las áreas comunes amobladas corresponden a imágenes de referencia, que no hacen parte de la oferta comercial, las mismas están sujetas a modificación y cambios discrecionales sin previo aviso o consulta 
                        por parte del constructor, conservando las características de calidad, seguridad e idoneidad.
                    </div>
                </div>
                <div className='btn-ingreso' onClick={() => {this.props.handleHideWelcome()}}>Ingresar</div>
            </div>
        )
    }
}

export default WelcomeScreen